"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _LoadingSpinnerWs = _interopRequireDefault(require("./LoadingSpinner.ws10.theme"));

var _LoadingSpinnerVoxi = _interopRequireDefault(require("./LoadingSpinner.voxi.theme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var getLocalThemes = function getLocalThemes(theme) {
  if (theme.name === 'WS2' || theme.name === 'WS10') {
    return (0, _LoadingSpinnerWs["default"])(theme);
  }

  return (0, _LoadingSpinnerVoxi["default"])(theme);
};

var _default = getLocalThemes;
exports["default"] = _default;
//# sourceMappingURL=LoadingSpinner.theme.js.map